import { css } from 'styled-components'

const slideUpReveal = () => css`
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-iteration-count: 1;
  animation-name: common-slide-in-up;
  animation-timing-function: cubic-bezier(0.405, 0.175, 0, 1.025);
`

export { slideUpReveal }
